<template>
  <div>
    <fieldset class="pt-2">
      <legend class="sr-only">{{ name }}</legend>
      <div class="row no-gutters">
        <div v-for="option in options" :key="option.value" class="col-auto">
          <div class="pr-3">
            <input
              :id="option.label"
              type="radio"
              v-model="innerValue"
              :aria-checked="innerValue"
              :name="name"
              :value="option.value"
              :style="{ 'background-color': option.hexCode }"
            />
            <label :aria-label="option.label" :for="option.label" class="sr-only"> {{ option.label }}</label>
          </div>
        </div>
      </div>
    </fieldset>
  </div>
</template>

<script>
export default {
  name: 'ColourSelect',
  components: {},
  props: {
    name: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
    value: {
      type: null,
    },
    hiddenLabel: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      innerValue: null,
    };
  },
  watch: {
    innerValue(newVal) {
      this.$emit('input', newVal);
    },
    value(newVal) {
      this.innerValue = newVal;
    },
  },
  created() {
    if (this.value) {
      this.innerValue = this.value;
    }
  },
};
</script>

<style lang="scss" scoped>
@import 'src/assets/scss/variables';

input[type='radio'] {
  width: 48px;
  height: 48px;
  appearance: none;
  border: 2px solid #dae2ea;
  border-radius: 50%;
  cursor: pointer;
}

input[type='radio']:checked {
  border: 2px solid #ffffff;
  box-shadow: 0 0 0 2px $primary;
}

input[type='radio']:focus {
  border: 2px solid #ffffff;
  box-shadow: 0 0 0 2px $primary;
}
</style>
